import { UrlConstants } from "../url.constants";
export class ApiEscalationsConstants {
    static URL = UrlConstants.API_V2 + "Escalation";
    static FUNCTION_UPDATE_ESCALATION = "UpdateEscalation";
    static FUNCTION_SET_ESCALATION_ITEMS = "SetEscalationItems";
}
